import React from "react";
import { Row, Col } from "antd";
import constantsMsgs from "../../../constants/messages";
import ServiceNonDox from "./ServiceNonDox";

const NonDox = ({ allAppData, summaryDate, bookingType }) => {
  return (
    <div className="modal-content">
      <Row>
        <Col span={24}>
          <Row>
            <div className="title highlight">
              <h4>Booking Details</h4>
            </div>
          </Row>
          <Row className="booking-details">
            <Col md={8} lg={8} xs={12} sm={12}>
              <div className="col">
                <p>
                  {constantsMsgs?.AWB_NO} &nbsp;&nbsp;&nbsp;{"  "}
                  <span className="highlight">{allAppData?.awbNumber}</span>
                </p>
              </div>
              <div>
                <p>{constantsMsgs?.BOOKING_FROM}</p>{" "}
              </div>
              <div className="highlight">
                {allAppData?.addressDetails?.senderCity}
              </div>
            </Col>
            <Col md={14} lg={14} xs={12} sm={12}>
              <div className="col">
                <p>
                  {constantsMsgs?.BOOKING_DATE}&nbsp;{" "}
                  <span className="highlight">
                    {summaryDate?.split("-")?.reverse()?.join(".")}
                  </span>
                </p>
              </div>
              <div>
                <p>{constantsMsgs?.BOOKING_TO}</p>{" "}
              </div>
              <div className="highlight">
                {allAppData?.addressDetails?.receiverCity}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="address" gatter={32}>
        <Col>
          <Row>
            <div className="title">
              <h4>Address</h4>
            </div>
          </Row>
          <Row>
            <Col md={12} lg={12} sm={24} xs={24}>
              <div className="card ">
                <div>
                  <h4>{allAppData?.addressDetails?.senderName}</h4>
                </div>
                <div>
                  <p>
                    {allAppData?.addressDetails?.senderCity},{" "}
                    {allAppData?.addressDetails?.senderAddressLine1},{" "}
                    {allAppData?.addressDetails?.senderAddressLine2}{" "}
                    {allAppData?.addressDetails?.senderState},{" "}
                    {allAppData?.addressDetails?.senderPincode}
                  </p>
                  <p>Area: {allAppData?.addressDetails?.senderArea}</p>
                  <p>
                    Phone no. {allAppData?.addressDetails?.senderMobileNumber}
                  </p>
                </div>
              </div>
            </Col>
            <Col md={12} lg={12} sm={24} xs={24}>
              <div className="card card-one">
                <div>
                  <h4>{allAppData?.addressDetails?.receiverName}</h4>
                </div>
                <div>
                  <p>
                    {allAppData?.addressDetails?.receiverCity},{" "}
                    {allAppData?.addressDetails?.receiverAddressLine1},{" "}
                    {allAppData?.addressDetails?.receiverState},{" "}
                    {allAppData?.addressDetails?.receiverPincode}
                  </p>
                  <p>Area: {allAppData?.addressDetails?.receiverAreaName}</p>
                  <p>
                    Phone no. {allAppData?.addressDetails?.receiverMobileNumber}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="service">
        <Col span={24}>
          <Row>
            <div className="title">
              <h4>Service Details</h4>
            </div>
          </Row>
        </Col>
      </Row>
      <Row>
        <ServiceNonDox allAppData={allAppData} />
      </Row>
      {/* {allAppData?.charges !== null && ( */}
      {bookingType == "Cash" && (
        <Row className="payment">
          <Col span={24}>
            <Row>
              <div className="title">
                <h4>Payment</h4>
              </div>
            </Row>
            <Row>
              <Col md={12} lg={12} sm={24} xs={24}>
                <div className="card left-card">
                  <Row>
                    <Col span={12} className="key">
                      <p>Total Charges: </p>
                      <p>SGST @ 9% : </p>
                      <p className="last">CGST @ 9% : </p>
                    </Col>
                    <Col span={12} className="value">
                      <p>{allAppData?.charges?.charges}</p>
                      <p>
                        {allAppData?.charges?.sgst
                          ? allAppData?.charges?.sgst
                          : "00.00"}
                      </p>
                      <p className="last">
                        {allAppData?.charges?.cgst
                          ? allAppData?.charges?.cgst
                          : "00.00"}
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={12} lg={12} sm={24} xs={24}>
                <div className="card right-card">
                  <Row>
                    <Col span={12} className="key">
                      <p> {constantsMsgs?.IGST}: </p>
                      <p>{constantsMsgs?.CESS} : </p>
                      <p className="last"></p>
                    </Col>
                    <Col span={12} className="value">
                      <p>
                        {allAppData?.charges?.igst
                          ? allAppData?.charges?.igst
                          : "00.00"}
                      </p>
                      <p>
                        {allAppData?.charges?.cess
                          ? allAppData?.charges?.cess
                          : "00.00"}
                      </p>
                      <p className="last"></p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          <Col className="frieght-class">
            <p id="frieght"> Frieght :</p>
            <p id="frieghtValue">{allAppData?.charges?.freight}</p>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default NonDox;
